import { useSharedHomepageData } from './queries/useSharedHomepageData';

/**
 * Hook to check if blog data exists for conditional navigation rendering
 */
export const useHasBlogData = (): boolean => {
  const { data: homepageData } = useSharedHomepageData();
  
  const blogPosts = homepageData?.blog_posts || [];
  return blogPosts.length > 0;
};
